import * as React from 'react';
import type { liveSearchApiClient } from '@/scopes/search/search/infrastructure/live-search/api';
import { createLiveSearchApiClient } from '@/scopes/search/search/infrastructure/live-search/api/liveSearchApiClient';

interface HeaderDependencies {
  liveSearchApiClient: typeof liveSearchApiClient;
}

const defaultDependencies: HeaderDependencies = {
  liveSearchApiClient: createLiveSearchApiClient({ contextItemId: '' }),
};

const HeaderDependenciesContext = React.createContext<HeaderDependencies>(defaultDependencies);

export const HeaderDependenciesProvider = ({
  children,
  dependencies = defaultDependencies,
}: React.PropsWithChildren<{ dependencies?: HeaderDependencies }>) => {
  return <HeaderDependenciesContext.Provider value={dependencies}>{children}</HeaderDependenciesContext.Provider>;
};

export const useHeaderDependencies = () => {
  return React.useContext(HeaderDependenciesContext);
};
